import './styles';

import {Box} from '@mui/material';

import {CoparentBenefits, CoparentFooter, CoparentHeader} from './components';
import {
  CoparentViewModelProvider,
  useCoparentViewModelProvider,
} from './CoparentViewModelContext';

const CoparentContent = () => {
  const {inviterName, kids, handleAcceptInvite} =
    useCoparentViewModelProvider();

  return (
    <section className="co-parent-background">
      <Box className="co-parent-container">
        <CoparentHeader inviterName={inviterName} />
        <CoparentBenefits />
        <CoparentFooter
          kids={kids}
          onAcceptInvite={handleAcceptInvite}
        />
      </Box>
    </section>
  );
};

const CoparentPage = () => (
  <CoparentViewModelProvider>
    <CoparentContent />
  </CoparentViewModelProvider>
);

export default CoparentPage;
